export default function LoadingBar() {
  return (
    <svg width='240' height='63' viewBox='0 0 240 63' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='19.0334' y='38.4834' width='27.0603' height='7.61072' fill='#391998' />
      <rect x='218.181' y='19.4565' width='3.80536' height='22.8322' fill='#7C6EB1' />
      <rect width='3.80536' height='22.8322' transform='matrix(-1 0 0 1 19.0334 19.4565)' fill='#7C6EB1' />
      <rect x='214.375' y='15.2285' width='3.80536' height='27.0603' fill='#7C6EB1' />
      <rect width='3.80536' height='27.0603' transform='matrix(-1 0 0 1 22.8389 15.2285)' fill='#7C6EB1' />
      <rect x='19.0334' y='11' width='198.724' height='4.22818' fill='#E9E2FF' />
      <rect x='19.0334' y='46.0942' width='198.724' height='4.22818' fill='#E9E2FF' />
      <rect width='4.22818' height='4.22818' transform='matrix(1 0 0 -1 218.181 19.4565)' fill='#E9E2FF' />
      <rect
        x='19.0334'
        y='19.4565'
        width='4.22818'
        height='4.22818'
        transform='rotate(180 19.0334 19.4565)'
        fill='#E9E2FF'
      />
      <rect width='4.22818' height='4.22818' transform='matrix(1 0 0 -1 218.181 46.5171)' fill='#E9E2FF' />
      <rect
        x='19.0334'
        y='46.5171'
        width='4.22818'
        height='4.22818'
        transform='rotate(180 19.0334 46.5171)'
        fill='#E9E2FF'
      />
      <rect width='4.22818' height='23.255' transform='matrix(1 0 0 -1 221.986 42.2886)' fill='#E9E2FF' />
      <rect
        x='15.228'
        y='42.2886'
        width='4.22818'
        height='23.255'
        transform='rotate(180 15.228 42.2886)'
        fill='#E9E2FF'
      />
      <rect x='46.0938' y='15.2285' width='4.22818' height='30.8657' fill='#E9E2FF' />
      <rect x='81.1875' y='15.2285' width='4.22818' height='30.8657' fill='#E9E2FF' />
      <rect x='116.282' y='15.2285' width='4.22818' height='30.8657' fill='#E9E2FF' />
      <rect x='151.375' y='15.2285' width='4.22818' height='30.8657' fill='#E9E2FF' />
      <rect x='186.892' y='15.2285' width='4.22818' height='30.8657' fill='#E9E2FF' />
      <rect x='22.8389' y='15.2285' width='23.255' height='23.255' fill='#7652E1' />
      <rect x='50.322' y='15.2285' width='30.8657' height='23.255' fill='#7652E1' />
      <rect x='85.4158' y='15.2285' width='30.8657' height='23.255' fill='#7652E1' />
      <rect x='120.51' y='15.2285' width='30.8657' height='23.255' fill='#7652E1' />
      <rect x='50.322' y='38.4834' width='30.8657' height='7.61072' fill='#391998' />
      <rect x='85.4158' y='38.4834' width='30.8657' height='7.61072' fill='#391998' />
      <rect x='120.51' y='38.4834' width='30.8657' height='7.61072' fill='#391998' />
      <rect x='155.604' y='38.4834' width='30.8657' height='7.61072' fill='#7C6EB1' />
      <rect x='191.12' y='38.4834' width='27.0603' height='7.61072' fill='#7C6EB1' />
    </svg>
  )
}
